// The different types of aggregates that can be displayed
export enum AggregateValueTypes {
    token = "token",
    dollar = "dollar",
    dollarCompact = "dollar_compact",
    percent = "percent",
    year = "year",
    count = "count",
    countCompact = "count_compact",
    bps = "bps",
}
export type AggregateValueType = `${AggregateValueTypes}` | AggregateValueTypes;

type PercentChangeInterval = "1h" | "12h" | "24h" | "7d" | "14d" | "30d";
export interface PercentChangeProps {
    value: number;
    interval: PercentChangeInterval;
}
